import { render, staticRenderFns } from "./JComponents.vue?vue&type=template&id=7a70ac35"
import script from "./JComponents.vue?vue&type=script&lang=js"
export * from "./JComponents.vue?vue&type=script&lang=js"
import style0 from "./JComponents.vue?vue&type=style&index=0&id=7a70ac35&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports